var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIgluLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1339,
    height: 480,
    viewBox: "0 0 1339 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 188.752,
    y: 448.867,
    width: 103.785,
    height: 103.784,
    rx: 31.1355,
    transform: "rotate(-90 188.752 448.867)",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 103.785,
    height: 103.785,
    rx: 31.1355,
    transform: "matrix(0.866024 -0.500002 0.499997 0.866027 32.4329 298.379)",
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 103.785,
    height: 103.785,
    rx: 31.1354,
    transform: "matrix(-0.866024 -0.500002 0.499999 -0.866027 121.947 233.514)",
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 188.751,
    y: 134.917,
    width: 103.785,
    height: 103.784,
    rx: 31.1355,
    transform: "rotate(-90 188.751 134.917)",
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 103.785,
    height: 103.785,
    rx: 31.1355,
    transform: "matrix(0.866024 -0.500002 0.499997 0.866027 306.165 143.999)",
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 103.785,
    height: 103.785,
    rx: 31.1354,
    transform: "matrix(-0.866024 -0.500002 0.499999 -0.866027 395.679 387.893)",
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M555.936 128.065C561.905 133.994 569.296 136.958 578.108 136.958C586.636 136.958 593.884 133.994 599.853 128.065C605.823 122.137 608.807 114.797 608.807 106.045C608.807 97.2936 605.823 89.9536 599.853 84.0252C593.884 78.0967 586.636 75.1325 578.108 75.1325C569.296 75.1325 561.905 78.0967 555.936 84.0252C549.967 89.9536 546.982 97.2936 546.982 106.045C546.982 114.797 549.967 122.137 555.936 128.065Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M602.367 167.87V402.292H554.71V167.87H602.367Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M878.005 192.343C870.376 177.627 859.796 166.437 846.234 159.079C832.672 151.438 816.991 147.618 799.19 147.618C779.695 147.618 762.319 152.004 747.061 160.777C731.804 169.55 719.796 182.003 711.037 198.134C702.561 214.265 698.323 232.943 698.323 254.168C698.323 275.394 702.561 294.213 711.037 310.627C719.796 326.759 731.804 339.211 747.061 347.984C762.319 356.757 779.695 361.144 799.19 361.144C825.467 361.144 846.799 353.785 863.186 339.069C879.574 324.353 889.604 303.828 893.277 278.641H782.662V240H944.982V402.292H897.325V368.641C897.325 363.04 892.784 358.499 887.183 358.499C883.542 358.499 880.185 360.428 878.054 363.38C869.453 375.289 843.621 404.868 799.19 404.868C743.56 404.868 696.06 378.173 668.656 331.853C655.376 308.929 648.736 283.035 648.736 254.168C648.736 225.302 655.376 199.407 668.656 176.484C682.218 153.561 700.442 135.731 723.328 122.996C746.496 109.978 771.784 103.469 799.19 103.469C830.553 103.469 858.383 111.252 882.682 126.817C907.263 142.099 924.947 164.043 935.966 192.343H878.005Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1315.93 402.292V167.87H1268.28V296.45C1268.28 317.422 1262.68 333.577 1251.9 344.913C1241.41 355.966 1227.08 361.493 1208.92 361.493C1190.77 361.493 1176.44 355.966 1165.95 344.913C1155.45 333.577 1149.78 317.422 1149.78 296.45V167.87H1102.12V303.677C1102.12 324.933 1106.24 343.071 1114.46 358.092C1131.37 387.94 1163.92 404.868 1198.71 404.868C1225.65 404.868 1243.31 380.925 1249.91 370.12C1251.81 367.011 1255.13 364.939 1258.78 364.939C1264.02 364.939 1268.28 369.192 1268.28 374.438V402.292H1315.93Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1077.65 362.363H1036.43V103.469H988.775V329.81C988.775 371.263 1022.38 404.868 1063.83 404.868H1077.65V362.363Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgluLogo);
export default __webpack_public_path__ + "static/media/iglu-logo.d3ea4b9ae0ceb706c7c2403878653eb3.svg";
export { ForwardRef as ReactComponent };